module.exports = __webpack_public_path__ + "assets/img/serce.dc2a5f3c.png";